/// 
import { defineStore } from 'pinia'

export const useAboutStore = defineStore('aboutStore', {
    state: () => ({
        isLoaded: false, 
        txthtml001 : '',
        aboutImg000 : '',
    }),
    actions: {
        async fetchAboutData() {
            const versionStr = "aboutVersion"
            const aboutVersion = localStorage.getItem(versionStr) ? localStorage.getItem(versionStr) : null
            console.log('aboutVersion:', aboutVersion)
            if (this.isLoaded) return // 已載入過就直接 return
            try {
                const res = await fetch('/api/load/aboutpage',
                    {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                        },
                        body: JSON.stringify({ aboutVersion }),
                    }
                )
                const json = await res.json()
                if (json.success) {
                    if (json.isUpdated) {
                        this.txthtml001 = json.txthtml001
                        this.aboutImg000 = json.aboutImg000
                        localStorage.setItem('txthtml001', json.txthtml001)
                        localStorage.setItem('aboutImg000', json.aboutImg000)
                        localStorage.setItem(versionStr, json.serverVersion)
                    } else {
                        const saveTxthtml001 = localStorage.getItem('txthtml001')
                        const saveAboutImg000 = localStorage.getItem('aboutImg000')
                        this.txthtml001 = saveTxthtml001 || ''
                        this.aboutImg000 = saveAboutImg000 || ''
                    }
                    this.isLoaded = true  // 標記為「已載入」
                } else {
                    console.warn('取得fetchHomeData失敗', json.message)
                }
            } catch (err) {
                console.error('fetch error:', err)
            }
        },
    },
})
